// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* common start */
*,
*::after,
*::before {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
}

.container {
  max-width: 100%;
}

.common-width {
  width: calc(100% - 80px);
  margin: auto;
}

/* common end */

/* header start */
.header {
  background: #3052a4;
  backdrop-filter: blur(32px);
  z-index: 999;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.header-logo-job {
  display: flex;
  gap: 106px;
  padding: 29px 0px;
  align-items: center;
  background: white;
  height: 65px;
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);
  /* outline: 3px solid red; */
}

.header-log-job-clip-path {
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);
  background-color: #6f86bf;
}

.upper-header-bar {
  opacity: 0;
}

.header-logo {
  font-weight: 700;
  font-size: 14px;
  line-height: 130%;
  color: #000000;
  text-decoration: none;

}

.header-job {
  font-weight: 700;
  font-size: 14px;
  line-height: 130%;
  text-decoration: none;
  /* color: #fff; */
}

.header-menu {
  font-weight: 750;
  font-size: 16px;
  line-height: 130%;
  color: #ffffff;
  text-decoration: none;
}
.header-job-active {
  font-weight: 800;
  font-size: 16px;
  line-height: 138%;
  color: #1A237E;
  /* solid dark blue text */
  text-decoration: none;
  background: #f9fafb; 
  padding: 14px 16px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  /* box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); */
  position: relative;
  top: 2px;
  -webkit-text-stroke: 0;
  /* removes red stroke */
  outline: none;
  /* removes browser focus outline */
  margin-bottom: -12px;
}

.header-menu-list {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;

}

@media screen and (max-width:780px) {
  .header-menu-list {
    display: none;
  }
}

.tss-dbu3l1-MUIDataTableViewCol-formGroup {
  align-items: start !important;
}

.header-search {
  position: relative;
}

.header-search-icon {
  position: absolute;
  top: 8px;
  left: 19px;
}

.header-search-input {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  outline: none;
  height: 36px;
  padding-left: 50px;
  width: 100%;
}

.header-search-input::placeholder {
  color: #adb5bd;
  font-family: "Inter";
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
}

.Header-lower-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap !important;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 223px !important;

}

@media screen and (max-width:1280px) {
  .Header-lower-bar {
    display: none;
  }

}

.header-user {
  display: flex;
  gap: 16px;
  padding: 15.5px 0;
  cursor: pointer;
}

.header-name {
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
  color: #232d42;
}

.header-role {
  font-weight: 400;
  font-size: 11px;
  line-height: 130%;
  color: #8a92a6;
}

/* header end */

/* title top start */
.tt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  padding: 40px 0px;
  flex-wrap: wrap;
}

.tt-back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 21px;
  flex-wrap: wrap;
}

.tt-back-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
}

.tt-back-create {
  font-weight: 700;
  font-size: 20px;
  line-height: 175%;
  color: #000000;
}

.tt-create {
  padding: 8px 24px;
  background: #068b92;
  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);
  color: #ffffff;
  border-radius: 4px;
  cursor: pointer;
}

.tt-dot-bar {
  position: relative;
  z-index: 40;
}

.tt-bar {
  cursor: pointer;
}

/* title top end */

/* create-candidate-start */
.cc {
  background: #f9f9f9;
  border-radius: 10px 10px 0px 0px;
  padding: 27px 31px 90px 31px;
  display: flex;
  gap: 44px;
}

.cc-left {
  overflow-y: scroll;
  height: 120vh;
  width: 70%;
}

.cc-right {
  width: 30%;
}

.cc-pd {
  font-weight: 700;
  font-size: 20px;
  line-height: 175%;
  color: #000000;
}

.cc-form-content {
  display: flex;
  gap: 20px;
  margin-top: 17px;
}

.cc-label {
  font-weight: 400;
  font-size: 15px;
  line-height: 175%;
  color: #000000;
  text-align: left;
}

.cc-input {
  background: #ffffff;
  border: 0.5px solid #bfbfbf;
  border-radius: 5px;
  height: 35px;
  margin-top: 3px;
  width: 400px;
  font-family: "Inter";
  padding: 6px 14px;
  outline: 0;
}

.cc-form-select-double {
  width: 140px;
}

.cc-input::placeholder {
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
}

.cc-form-select {
  position: relative;
}

.cc-form-select-icon {
  position: absolute;
  top: 45px;
  right: 13px;
}

select {
  appearance: none;
}

.cc-edu {
  margin-top: 44px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #d1d1d1;
  border-radius: 7.5px 7.5px 0px 0px;
}

::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 7.5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
  border-radius: 7.5px;
}

/* create-candidate-end */

/* hiring status start */
.content-top-border {
  border: 1px solid #adb5bd;
}

.ct-content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  margin-top: 15px;
}

.ct-content__left {
  width: 35%;
}

.ct-content__right {
  width: 55%;
}

.ct-content-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 175%;
  color: #000000;
}

.ct-content-des {
  font-weight: 400;
  font-size: 20px;
  line-height: 175%;
  color: #000000;
}

.ct-content-btn {
  background: #109cf1;
  /* box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3); */
  padding: 15px 34px;
  color: #ffffff;
  cursor: pointer;
}

.ct-content-hs-reletive {
  position: relative;
}

.ct-content-hs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #068b92;
  cursor: pointer;
}

.ct-content-btn__hs {
  background: #068b92;
}

.ct-content-btn-icon {
  margin-right: 16px;
}

.ct-content-hs-items {
  position: absolute;
  top: 56px;
  right: -1px;
  background: #ffffff;
  border: 1px solid #919191;
  border-radius: 10px;
  width: 198px;
}

.ct-content-hs-list {
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
  padding: 18px 22px;
  border: 1px solid #bfbfbf;
  cursor: pointer;
  width: 100%;
}

/* candidate profile start */
.can-pro {
  display: flex;
}

.can-pro-left {
  margin: 19px 0;
  overflow-y: scroll;
  height: 100vh;
  padding: 0px 38px 20px 0;
  width: 70%;
}

.content-top-border__can-pro {
  margin-top: 25px;
}

.can-pro-left-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 175%;
  color: #109cf1;
  margin-bottom: 19px;
}

.can-pro-left-item {
  display: flex;
  gap: 10px;
  margin-bottom: 19px;
}

.can-pro-left-content {
  margin-top: 23px;
}

.can-pro-left-item-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
  padding-right: 185px;
  width: 131px;
}

.can-pro-left-item-des {
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
}

.can-pro-left-item__work {
  border-bottom: 1px solid #adb5bd;
  margin-bottom: 0px;
  gap: 0px;
}

.can-pro-left-work-title {
  background: #e0e0e0;
  font-weight: 500;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
  padding: 6px 0px;
  width: 236px;
  text-align: center;
}

.can-pro-left-work-des-item {
  display: flex;
  align-items: center;
  background: #f4f4f4;
  padding: 6px 14px;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
}

.can-pro-left-work-des {
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
}

.can-pro-right {
  width: 30%;
  padding: 19px 24px;
  overflow-y: scroll;
  height: 100vh;
  margin: 19px 0;
}

.can-pro-right-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 175%;
  color: #000000;
  text-align: center;
}

.cc-input__input {
  width: 200px;
  height: 50px;
}

.can-pro-plus {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: space-between;
}

.can-pro-right-comment {
  margin-top: 25px;
}

.can-pro-right-comment-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 175%;
  color: #000000;
}

.can-pro-right-comment-des {
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
  color: #414141;
  background: #ebebeb;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  padding: 7px 20px;
  width: 100%;
}

.can-pro-right-comment-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  margin-top: 4px;
}

.can-pro-right-comment-info-details {
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
  color: #919191;
}

/* candidate profile end */
/* hiring status end */

/* schedule interview start */
.sched-inter-content-main {
  background: #f9f9f9;
  border-radius: 10px 10px 0px 0px;
  padding: 60px 40px;
}

.sched-inter-content {
  display: flex;
  gap: 80px;
}

.sched-inter__input {
  width: 100%;
}

.sched-inter-location__label {
  width: 250px;
}

.sched-inter-content-left {
  width: 40%;
}

.sched-inter-content-left-checkbox-content {
  display: flex;
  align-items: center;
  gap: 11px;
}

.sched-inter-content-left-checkbox-main {
  display: flex;
  flex-direction: row;
  margin-top: 41px;
  gap: 37px;
  flex-wrap: wrap;
}

.sched-inter-content-left-checkbox {
  border: 2px solid #d5d5d5;
  border-radius: 4px;
}

.sched-inter-location {
  display: flex;
  align-items: center;
  margin-top: 40px;
}

.sched-inter-left-input {
  margin-top: 40px;
  display: flex;
  gap: 5px;
}

.sched-inter-select-icon {
  top: 18px;
}

.sched-inter-content-right {
  margin-top: 30px;
  width: 60%;
  margin: auto;
}

.sched-inter-content-border {
  border: 1px solid #919191;
}

.sched-inter-react-quill {
  margin-top: 40px;
}

.ql-container.ql-snow {
  background: #ffffff;
}

.quill {
  height: 130px;
}

.sched-inter-content-bottom-border {
  border: 1px solid #919191;
  margin-top: 43px;
}

.sched-inter-content-btn {
  background: #109cf1;
  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);
  border-radius: 4px;
  padding: 15px 0px;
  text-align: center;
  color: #ffffff;
  width: 213px;
  margin: 61px auto 0 auto;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.sched-inter-content-btn__send {
  margin: 61px 0 0 0;
}

.sched-inter-right-file-input {
  display: none;
}

.sched-inter-right-file-text {
  background: #9b9b9b;
  border: 0.5px solid #424242;
  border-radius: 5px;
  width: 330px;
  padding: 6px 30px;
  font-size: 13px;
  line-height: 175%;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

.sched-inter-right-file-label {
  margin-top: 40px;
}

.sched-inter-left-input-attach {
  margin-top: 70px;
}

/* schedule interview end */

/* modal start */
.modal {
  background: #ffffff;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  position: fixed;
  top: 10vh;
  left: 20vw;
  right: 0;
  bottom: 0;
  padding: 41px 105px;
  z-index: 50;
  width: 60%;
  height: 80%;
  margin: auto;
  overflow-y: scroll;
}

.modal-close {
  position: absolute;
  top: 37px;
  right: 37px;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.5;
}

.modal::-webkit-scrollbar {
  display: none;
}

/* modal end */

/* Assign job start */
/* .assjob-container{
  top: auto;
} */
.assjob-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 175%;
  color: #000000;
  text-align: center;
  margin-top: 40px;
}

.assjob-input-container {
  margin-top: 43px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.assjob-input-container-label {
  font-weight: 700;
  font-size: 16px;
  line-height: 175%;
  color: #000000;
  width: 200px;
}

.assjob-input-container-label-input {
  background: #f8f8f8;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  padding: 16px;
  width: 100%;
  outline: none;
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
  color: #000000;
}

.assjob-input-container-label-input::placeholder {
  font-weight: 400;
  font-size: 13px;
  line-height: 175%;
  color: #000000;
}

.assjob-submit-btn {
  background: #3a57e8;
  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);
  border-radius: 4px;
  padding: 13px 114px;
  text-align: center;
  width: 259px;
  margin: 38px auto 0 auto;
  cursor: pointer;
  color: #ffffff;
}

.editor2 {
  margin-bottom: 50px;
}

/* Assign job end */

/* .job-opening-info {
  padding-top: 64px; 
} */

.candidateBlueCard {
  background-color: #c4cdf8;
  box-shadow: rgba(58, 87, 232, 0.3);
  border-radius: 10px;
  padding: 2%;
}

.quickaccess {
  text-decoration: none;
  color: #000000;
  display: block;
  margin-top: 4%;
}

@media screen and (max-width: 780px) {
  .quickaccess {
    margin-top: 2%;
    font-size: 14px;
  }
}

.canhead {
  color: #557fff;
  text-align: center;
  margin-top: 2%
}

.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;


}

.scrolling-wrapper-flexbox>.card {
  flex: 0 0 auto;
}

.row {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.card {
  /*float: left;*/
  max-width: 25.333%;
  padding: .75rem;
  margin-bottom: 2rem;
  border: 0;
  flex-basis: 33.333%;
  flex-grow: 0;
  flex-shrink: 0;
}

.card > img {
  margin-bottom: .75rem;
  width: 100%;
}

.card-text {
  font-size: 85%;
}


/* TO do */
.app-wrapper {
  background-color: #12343b;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 10px;
}

.task-input {
  outline: none;
  padding: 15px;
  margin-right: 25px;
  font-size: 20px;
  color: #ccc;
  background-color: #000000;
  border: 1px solid #c89666;
  border-radius: 10px;
}

.button-add {
  width: 70px;
  padding: 15px 15px;
  font-size: 20px;
  border-radius: 10px;
  border: 0;
  background-color: #f1af71;
  cursor: pointer;
}

.list-item {
  display: flex;
  width: 50%;
  margin: 20px 0 10px 5%;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  /* height: 30px; */
}

.button-complete,
.button-delete {
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 28px;
  border-radius: 50%;
}

.button-complete {
  color: #ff6c6c;
  margin-right: 10px;
}

.button-delete {
  color: lightseagreen;
}

.complete {
  text-decoration-style: solid;
  text-decoration-line: line-through;
  text-decoration-color: blue;
  opacity: 0.6;
}

.list {
  width: 220px;
  border: none;
  color: #000000;
  font-size: 20px;
  padding-left: 10px;
  margin-right: 15px;
}

input:focus,
button:focus {
  outline: none;
}

.btnstodo {
  margin-left: 20%;
}

.interviewPic {
  width: 50px;
}

.MuiTableCell-root {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MuiTableContainer-root {
  overflow-x: auto;
}

.tss-1cn2w2t-MUIDataTableBodyCell-root {
  text-align: left !important;
}

.dropdown-content {
  z-index: 1000 !important;
}

.MuiTableRow-root th span {
  justify-content: left !important;
}

.css-5bjqim-MuiPaper-root-MuiPopover-paper {
  top: 15% !important;
  height: auto !important;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: -1px -1px 20px -2px rgb(0 0 0), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12) !important;
}

@media (min-width: 1200px) and (max-width: 1370px) {
  .card-set-1366 {
    margin-top: -2% !important;
  }
}

.css-1fmcalr-MuiTableCell-root {
  background-color: #f4f4ff !important;
}

.MuiTableHead-root .MuiTableCell-root:first-child {
  background-color: #f4f4ff !important;
}

.css-429m73-MuiTableCell-root {
  padding: 8px 16px !important;
}

@media (min-width: 1200px) {
  .css-7ukbs8-MuiContainer-root {
    max-width: 100%;
  }
}

/* DataGrid Focus Styles */
.MuiDataGrid-columnHeader:focus,
.MuiDataGrid-cell:focus,
.MuiDataGrid-columnHeader:focus-within,
.MuiDataGrid-cell:focus-within,
.MuiDataGrid-columnHeader:focus-visible,
.MuiDataGrid-cell:focus-visible,
.MuiDataGrid-columnHeader.Mui-focused,
.MuiDataGrid-cell.Mui-focused {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  border-color: transparent !important;
}

.MuiDataGrid-columnHeader:focus-visible .MuiDataGrid-menuIcon,
.MuiDataGrid-columnHeader:focus-visible .MuiDataGrid-sortIcon {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA,eAAe;;AAEf,iBAAiB;AACjB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,sFAAsF;EACtF,4BAA4B;AAC9B;;AAEA;EACE,sFAAsF;EACtF,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;;AAEvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,+CAA+C;EAC/C,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;;AAEjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,uBAAuB;;AAEzB;;AAEA;EACE;IACE,aAAa;EACf;;AAEF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;;AAEf,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;;AAElB,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yBAAyB;;AAEzB,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B,sBAAsB;;AAEtB,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B,gBAAgB;AAChB;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;;AAEd,qBAAqB;AACrB;;GAEG;AACH;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB;;GAEG;;AAEH;EACE,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;;;AAGlB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA,UAAU;AACV;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,2IAA2I;AAC7I;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;;;;;;;;EAQE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;AACZ","sourcesContent":["/* common start */\n*,\n*::after,\n*::before {\n  box-sizing: inherit;\n}\n\nhtml {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", sans-serif;\n}\n\n.container {\n  max-width: 100%;\n}\n\n.common-width {\n  width: calc(100% - 80px);\n  margin: auto;\n}\n\n/* common end */\n\n/* header start */\n.header {\n  background: #3052a4;\n  backdrop-filter: blur(32px);\n  z-index: 999;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.header-logo-job {\n  display: flex;\n  gap: 106px;\n  padding: 29px 0px;\n  align-items: center;\n  background: white;\n  height: 65px;\n  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);\n  /* outline: 3px solid red; */\n}\n\n.header-log-job-clip-path {\n  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);\n  background-color: #6f86bf;\n}\n\n.upper-header-bar {\n  opacity: 0;\n}\n\n.header-logo {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 130%;\n  color: #000000;\n  text-decoration: none;\n\n}\n\n.header-job {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 130%;\n  text-decoration: none;\n  /* color: #fff; */\n}\n\n.header-menu {\n  font-weight: 750;\n  font-size: 16px;\n  line-height: 130%;\n  color: #ffffff;\n  text-decoration: none;\n}\n.header-job-active {\n  font-weight: 800;\n  font-size: 16px;\n  line-height: 138%;\n  color: #1A237E;\n  /* solid dark blue text */\n  text-decoration: none;\n  background: #f9fafb; \n  padding: 14px 16px;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  /* box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); */\n  position: relative;\n  top: 2px;\n  -webkit-text-stroke: 0;\n  /* removes red stroke */\n  outline: none;\n  /* removes browser focus outline */\n  margin-bottom: -12px;\n}\n\n.header-menu-list {\n  display: flex;\n  gap: 40px;\n  flex-wrap: wrap;\n\n}\n\n@media screen and (max-width:780px) {\n  .header-menu-list {\n    display: none;\n  }\n}\n\n.tss-dbu3l1-MUIDataTableViewCol-formGroup {\n  align-items: start !important;\n}\n\n.header-search {\n  position: relative;\n}\n\n.header-search-icon {\n  position: absolute;\n  top: 8px;\n  left: 19px;\n}\n\n.header-search-input {\n  background: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  outline: none;\n  height: 36px;\n  padding-left: 50px;\n  width: 100%;\n}\n\n.header-search-input::placeholder {\n  color: #adb5bd;\n  font-family: \"Inter\";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n}\n\n.Header-lower-bar {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap !important;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  width: 223px !important;\n\n}\n\n@media screen and (max-width:1280px) {\n  .Header-lower-bar {\n    display: none;\n  }\n\n}\n\n.header-user {\n  display: flex;\n  gap: 16px;\n  padding: 15.5px 0;\n  cursor: pointer;\n}\n\n.header-name {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n  color: #232d42;\n}\n\n.header-role {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 130%;\n  color: #8a92a6;\n}\n\n/* header end */\n\n/* title top start */\n.tt {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  padding: 40px 0px;\n  flex-wrap: wrap;\n}\n\n.tt-back {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 21px;\n  flex-wrap: wrap;\n}\n\n.tt-back-info {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.tt-back-create {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.tt-create {\n  padding: 8px 24px;\n  background: #068b92;\n  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);\n  color: #ffffff;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tt-dot-bar {\n  position: relative;\n  z-index: 40;\n}\n\n.tt-bar {\n  cursor: pointer;\n}\n\n/* title top end */\n\n/* create-candidate-start */\n.cc {\n  background: #f9f9f9;\n  border-radius: 10px 10px 0px 0px;\n  padding: 27px 31px 90px 31px;\n  display: flex;\n  gap: 44px;\n}\n\n.cc-left {\n  overflow-y: scroll;\n  height: 120vh;\n  width: 70%;\n}\n\n.cc-right {\n  width: 30%;\n}\n\n.cc-pd {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.cc-form-content {\n  display: flex;\n  gap: 20px;\n  margin-top: 17px;\n}\n\n.cc-label {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 175%;\n  color: #000000;\n  text-align: left;\n}\n\n.cc-input {\n  background: #ffffff;\n  border: 0.5px solid #bfbfbf;\n  border-radius: 5px;\n  height: 35px;\n  margin-top: 3px;\n  width: 400px;\n  font-family: \"Inter\";\n  padding: 6px 14px;\n  outline: 0;\n}\n\n.cc-form-select-double {\n  width: 140px;\n}\n\n.cc-input::placeholder {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n}\n\n.cc-form-select {\n  position: relative;\n}\n\n.cc-form-select-icon {\n  position: absolute;\n  top: 45px;\n  right: 13px;\n}\n\nselect {\n  appearance: none;\n}\n\n.cc-edu {\n  margin-top: 44px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #d1d1d1;\n  border-radius: 7.5px 7.5px 0px 0px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #979797;\n  border-radius: 7.5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n  border-radius: 7.5px;\n}\n\n/* create-candidate-end */\n\n/* hiring status start */\n.content-top-border {\n  border: 1px solid #adb5bd;\n}\n\n.ct-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n  margin-top: 15px;\n}\n\n.ct-content__left {\n  width: 35%;\n}\n\n.ct-content__right {\n  width: 55%;\n}\n\n.ct-content-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.ct-content-des {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.ct-content-btn {\n  background: #109cf1;\n  /* box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3); */\n  padding: 15px 34px;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.ct-content-hs-reletive {\n  position: relative;\n}\n\n.ct-content-hs {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #068b92;\n  cursor: pointer;\n}\n\n.ct-content-btn__hs {\n  background: #068b92;\n}\n\n.ct-content-btn-icon {\n  margin-right: 16px;\n}\n\n.ct-content-hs-items {\n  position: absolute;\n  top: 56px;\n  right: -1px;\n  background: #ffffff;\n  border: 1px solid #919191;\n  border-radius: 10px;\n  width: 198px;\n}\n\n.ct-content-hs-list {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n  padding: 18px 22px;\n  border: 1px solid #bfbfbf;\n  cursor: pointer;\n  width: 100%;\n}\n\n/* candidate profile start */\n.can-pro {\n  display: flex;\n}\n\n.can-pro-left {\n  margin: 19px 0;\n  overflow-y: scroll;\n  height: 100vh;\n  padding: 0px 38px 20px 0;\n  width: 70%;\n}\n\n.content-top-border__can-pro {\n  margin-top: 25px;\n}\n\n.can-pro-left-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 175%;\n  color: #109cf1;\n  margin-bottom: 19px;\n}\n\n.can-pro-left-item {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 19px;\n}\n\n.can-pro-left-content {\n  margin-top: 23px;\n}\n\n.can-pro-left-item-title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n  padding-right: 185px;\n  width: 131px;\n}\n\n.can-pro-left-item-des {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.can-pro-left-item__work {\n  border-bottom: 1px solid #adb5bd;\n  margin-bottom: 0px;\n  gap: 0px;\n}\n\n.can-pro-left-work-title {\n  background: #e0e0e0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n  padding: 6px 0px;\n  width: 236px;\n  text-align: center;\n}\n\n.can-pro-left-work-des-item {\n  display: flex;\n  align-items: center;\n  background: #f4f4f4;\n  padding: 6px 14px;\n  justify-content: space-between;\n  cursor: pointer;\n  width: 100%;\n}\n\n.can-pro-left-work-des {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.can-pro-right {\n  width: 30%;\n  padding: 19px 24px;\n  overflow-y: scroll;\n  height: 100vh;\n  margin: 19px 0;\n}\n\n.can-pro-right-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 175%;\n  color: #000000;\n  text-align: center;\n}\n\n.cc-input__input {\n  width: 200px;\n  height: 50px;\n}\n\n.can-pro-plus {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: space-between;\n}\n\n.can-pro-right-comment {\n  margin-top: 25px;\n}\n\n.can-pro-right-comment-title {\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.can-pro-right-comment-des {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n  color: #414141;\n  background: #ebebeb;\n  border: 1px solid #d5d5d5;\n  border-radius: 5px;\n  padding: 7px 20px;\n  width: 100%;\n}\n\n.can-pro-right-comment-info {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n\n.can-pro-right-comment-info-details {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n  color: #919191;\n}\n\n/* candidate profile end */\n/* hiring status end */\n\n/* schedule interview start */\n.sched-inter-content-main {\n  background: #f9f9f9;\n  border-radius: 10px 10px 0px 0px;\n  padding: 60px 40px;\n}\n\n.sched-inter-content {\n  display: flex;\n  gap: 80px;\n}\n\n.sched-inter__input {\n  width: 100%;\n}\n\n.sched-inter-location__label {\n  width: 250px;\n}\n\n.sched-inter-content-left {\n  width: 40%;\n}\n\n.sched-inter-content-left-checkbox-content {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n}\n\n.sched-inter-content-left-checkbox-main {\n  display: flex;\n  flex-direction: row;\n  margin-top: 41px;\n  gap: 37px;\n  flex-wrap: wrap;\n}\n\n.sched-inter-content-left-checkbox {\n  border: 2px solid #d5d5d5;\n  border-radius: 4px;\n}\n\n.sched-inter-location {\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n}\n\n.sched-inter-left-input {\n  margin-top: 40px;\n  display: flex;\n  gap: 5px;\n}\n\n.sched-inter-select-icon {\n  top: 18px;\n}\n\n.sched-inter-content-right {\n  margin-top: 30px;\n  width: 60%;\n  margin: auto;\n}\n\n.sched-inter-content-border {\n  border: 1px solid #919191;\n}\n\n.sched-inter-react-quill {\n  margin-top: 40px;\n}\n\n.ql-container.ql-snow {\n  background: #ffffff;\n}\n\n.quill {\n  height: 130px;\n}\n\n.sched-inter-content-bottom-border {\n  border: 1px solid #919191;\n  margin-top: 43px;\n}\n\n.sched-inter-content-btn {\n  background: #109cf1;\n  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);\n  border-radius: 4px;\n  padding: 15px 0px;\n  text-align: center;\n  color: #ffffff;\n  width: 213px;\n  margin: 61px auto 0 auto;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n}\n\n.sched-inter-content-btn__send {\n  margin: 61px 0 0 0;\n}\n\n.sched-inter-right-file-input {\n  display: none;\n}\n\n.sched-inter-right-file-text {\n  background: #9b9b9b;\n  border: 0.5px solid #424242;\n  border-radius: 5px;\n  width: 330px;\n  padding: 6px 30px;\n  font-size: 13px;\n  line-height: 175%;\n  color: #ffffff;\n  text-align: center;\n  cursor: pointer;\n}\n\n.sched-inter-right-file-label {\n  margin-top: 40px;\n}\n\n.sched-inter-left-input-attach {\n  margin-top: 70px;\n}\n\n/* schedule interview end */\n\n/* modal start */\n.modal {\n  background: #ffffff;\n  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);\n  border-radius: 20px;\n  position: fixed;\n  top: 10vh;\n  left: 20vw;\n  right: 0;\n  bottom: 0;\n  padding: 41px 105px;\n  z-index: 50;\n  width: 60%;\n  height: 80%;\n  margin: auto;\n  overflow-y: scroll;\n}\n\n.modal-close {\n  position: absolute;\n  top: 37px;\n  right: 37px;\n  cursor: pointer;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: #000000;\n  opacity: 0.5;\n}\n\n.modal::-webkit-scrollbar {\n  display: none;\n}\n\n/* modal end */\n\n/* Assign job start */\n/* .assjob-container{\n  top: auto;\n} */\n.assjob-title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 175%;\n  color: #000000;\n  text-align: center;\n  margin-top: 40px;\n}\n\n.assjob-input-container {\n  margin-top: 43px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.assjob-input-container-label {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 175%;\n  color: #000000;\n  width: 200px;\n}\n\n.assjob-input-container-label-input {\n  background: #f8f8f8;\n  border: 1px solid #d5d5d5;\n  border-radius: 5px;\n  padding: 16px;\n  width: 100%;\n  outline: none;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.assjob-input-container-label-input::placeholder {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 175%;\n  color: #000000;\n}\n\n.assjob-submit-btn {\n  background: #3a57e8;\n  box-shadow: 0px 2px 4px rgba(58, 87, 232, 0.3);\n  border-radius: 4px;\n  padding: 13px 114px;\n  text-align: center;\n  width: 259px;\n  margin: 38px auto 0 auto;\n  cursor: pointer;\n  color: #ffffff;\n}\n\n.editor2 {\n  margin-bottom: 50px;\n}\n\n/* Assign job end */\n\n/* .job-opening-info {\n  padding-top: 64px; \n} */\n\n.candidateBlueCard {\n  background-color: #c4cdf8;\n  box-shadow: rgba(58, 87, 232, 0.3);\n  border-radius: 10px;\n  padding: 2%;\n}\n\n.quickaccess {\n  text-decoration: none;\n  color: #000000;\n  display: block;\n  margin-top: 4%;\n}\n\n@media screen and (max-width: 780px) {\n  .quickaccess {\n    margin-top: 2%;\n    font-size: 14px;\n  }\n}\n\n.canhead {\n  color: #557fff;\n  text-align: center;\n  margin-top: 2%\n}\n\n.scrolling-wrapper-flexbox {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n\n\n}\n\n.scrolling-wrapper-flexbox>.card {\n  flex: 0 0 auto;\n}\n\n.row {\n  align-items: stretch;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.card {\n  /*float: left;*/\n  max-width: 25.333%;\n  padding: .75rem;\n  margin-bottom: 2rem;\n  border: 0;\n  flex-basis: 33.333%;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.card > img {\n  margin-bottom: .75rem;\n  width: 100%;\n}\n\n.card-text {\n  font-size: 85%;\n}\n\n\n/* TO do */\n.app-wrapper {\n  background-color: #12343b;\n  padding: 30px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.task-input {\n  outline: none;\n  padding: 15px;\n  margin-right: 25px;\n  font-size: 20px;\n  color: #ccc;\n  background-color: #000000;\n  border: 1px solid #c89666;\n  border-radius: 10px;\n}\n\n.button-add {\n  width: 70px;\n  padding: 15px 15px;\n  font-size: 20px;\n  border-radius: 10px;\n  border: 0;\n  background-color: #f1af71;\n  cursor: pointer;\n}\n\n.list-item {\n  display: flex;\n  width: 50%;\n  margin: 20px 0 10px 5%;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  padding: 10px;\n  /* height: 30px; */\n}\n\n.button-complete,\n.button-delete {\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 28px;\n  border-radius: 50%;\n}\n\n.button-complete {\n  color: #ff6c6c;\n  margin-right: 10px;\n}\n\n.button-delete {\n  color: lightseagreen;\n}\n\n.complete {\n  text-decoration-style: solid;\n  text-decoration-line: line-through;\n  text-decoration-color: blue;\n  opacity: 0.6;\n}\n\n.list {\n  width: 220px;\n  border: none;\n  color: #000000;\n  font-size: 20px;\n  padding-left: 10px;\n  margin-right: 15px;\n}\n\ninput:focus,\nbutton:focus {\n  outline: none;\n}\n\n.btnstodo {\n  margin-left: 20%;\n}\n\n.interviewPic {\n  width: 50px;\n}\n\n.MuiTableCell-root {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.MuiTableContainer-root {\n  overflow-x: auto;\n}\n\n.tss-1cn2w2t-MUIDataTableBodyCell-root {\n  text-align: left !important;\n}\n\n.dropdown-content {\n  z-index: 1000 !important;\n}\n\n.MuiTableRow-root th span {\n  justify-content: left !important;\n}\n\n.css-5bjqim-MuiPaper-root-MuiPopover-paper {\n  top: 15% !important;\n  height: auto !important;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: -1px -1px 20px -2px rgb(0 0 0), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12) !important;\n}\n\n@media (min-width: 1200px) and (max-width: 1370px) {\n  .card-set-1366 {\n    margin-top: -2% !important;\n  }\n}\n\n.css-1fmcalr-MuiTableCell-root {\n  background-color: #f4f4ff !important;\n}\n\n.MuiTableHead-root .MuiTableCell-root:first-child {\n  background-color: #f4f4ff !important;\n}\n\n.css-429m73-MuiTableCell-root {\n  padding: 8px 16px !important;\n}\n\n@media (min-width: 1200px) {\n  .css-7ukbs8-MuiContainer-root {\n    max-width: 100%;\n  }\n}\n\n/* DataGrid Focus Styles */\n.MuiDataGrid-columnHeader:focus,\n.MuiDataGrid-cell:focus,\n.MuiDataGrid-columnHeader:focus-within,\n.MuiDataGrid-cell:focus-within,\n.MuiDataGrid-columnHeader:focus-visible,\n.MuiDataGrid-cell:focus-visible,\n.MuiDataGrid-columnHeader.Mui-focused,\n.MuiDataGrid-cell.Mui-focused {\n  outline: none !important;\n  box-shadow: none !important;\n  border: none !important;\n  border-color: transparent !important;\n}\n\n.MuiDataGrid-columnHeader:focus-visible .MuiDataGrid-menuIcon,\n.MuiDataGrid-columnHeader:focus-visible .MuiDataGrid-sortIcon {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
